var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import { Portfolio as PortfolioModel, Portfolio } from '@/models/Portfolio';
import ErrorHandler from '@/support/ErrorHandler';
import { Student } from '@/models/Student';
import AddSkillsetDialog from '@/components/add-skillset-dialog/AddSkillsetDialog';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
let ProgressSkill = class ProgressSkill extends Vue {
    constructor() {
        super(...arguments);
        this.portfolioClone = null;
        this.skills = [];
        this.deleteSkills = [];
        this.ratingNumbers = [1, 2, 3];
        this.newSkillName = '';
        this.newSkillRatingNumber = 1;
        this.isAddingNewSkill = false;
        this.isEditingSkills = false;
        this.isUpdatingSkills = false;
        this.isConfirmingDeleteCategory = {
            dialog: false,
            categoryId: '',
        };
        this.activeTab = 'skillset-manual';
        this.isAddingSkillSet = false;
    }
    mounted() {
        this.initialize();
    }
    /**
     * Flat array of skills
     * Skill have category => {id: string, name: string}
     *
     * tabs of unique categories ==> needs an array of unique categories that i can loop over the show the tabs
     * when activeTab changes => you need to show (filter) skills with a specific category form the skills aray
     * per tab we needs all the skils form that category
     *
     *
     *
     * We need to send a list of already copied categories to the dialog so we can filter them out
     * We can only categories that havge skills (no empty catergories)
     */
    initialize() {
        this.portfolioClone = cloneDeep(this.portfolio);
        this.skills = this.portfolioClone.skills;
    }
    updateSkills() {
        this.skills.forEach((skill) => {
            const payload = {
                name: skill.name,
            };
            this.portfolio
                .updateRelation(this.portfolio.id, 'skills', skill.id, payload)
                .then(() => {
                this.$emit('portfolioUpdated');
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
        this.deleteSkills.forEach((skill) => {
            this.portfolio
                .deleteRelation(this.portfolio.id, 'skills', skill.id)
                .then(() => {
                this.$emit('portfolioUpdated');
            })
                .catch((error) => {
                ErrorHandler.network(error);
            });
        });
    }
    resetSkills() {
        this.deleteSkills = [];
        this.skills = cloneDeep(this.portfolio).skills;
        this.isEditingSkills = false;
    }
    deleteSkill(deletedSkill) {
        this.skills = this.skills.filter((skill) => {
            return skill.id !== deletedSkill.id;
        });
        this.deleteSkills.push(deletedSkill);
    }
    async onAddSkillCategory(category) {
        try {
            await new Portfolio()
                .createRelation(this.portfolio.id, 'skills/create-from-category', { category: category.id });
            this.$emit('portfolioUpdated');
        }
        catch (error) {
            //
        }
    }
    async addSkill() {
        const payload = {
            name: this.newSkillName,
            category: this.activeTab ? this.activeTab : undefined,
        };
        await this.portfolio
            .createRelation(this.portfolio.id, 'skills', payload)
            .then((skill) => {
            this.addSkillRating(skill);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    async addSkillRating(skill) {
        const payload = {
            rating: this.newSkillRatingNumber,
        };
        await this.portfolio
            .updateRelation(this.portfolio.id, 'rate', skill.id, payload)
            .then(() => {
            this.$emit('portfolioUpdated');
            this.resetAddingNewSkills();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    async updateSkillRating(skill, number) {
        const payload = {
            rating: number,
        };
        await this.portfolio
            .updateRelation(this.portfolio.id, 'rate', skill.id, payload)
            .then(() => {
            this.$emit('portfolioUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    canRate(skill, number) {
        if (!skill.ratings) {
            return true;
        }
        const currentUserRatings = skill.ratings.find((rating) => {
            return (rating.user && rating.user.id === this.$store.state.Auth.id);
        });
        if (!currentUserRatings) {
            return true;
        }
        else {
            return currentUserRatings.rating !== number;
        }
    }
    getRatingsByNumber(skill, number) {
        if (!skill.ratings) {
            return [];
        }
        return skill.ratings.filter((rating) => {
            return rating.rating === number;
        });
    }
    resetAddingNewSkills() {
        this.isAddingNewSkill = false;
        this.newSkillName = '';
        this.newSkillRatingNumber = 1;
    }
    async removeUserFromRating(skill, user) {
        await this.portfolio
            .updateRelation(this.portfolio.id, 'rate', skill.id, { rating: null, ...user ? { teacher_id: user.id } : {} })
            .then(() => {
            this.$emit('portfolioUpdated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getSkillsFormCategory(categoryId) {
        return this.skills.filter((skill) => {
            return skill.category && skill.category.id === categoryId;
        });
    }
    confirmRemoveSkillCategory(categoryId) {
        this.isConfirmingDeleteCategory.dialog = true;
        this.isConfirmingDeleteCategory.categoryId = categoryId;
        this.isAddingSkillSet = true;
    }
    async deleteSkillCategory() {
        try {
            await new Portfolio()
                .deleteRelationWithPayload(this.portfolio.id, 'skills/delete-from-category', { category: this.isConfirmingDeleteCategory.categoryId });
            this.$emit('portfolioUpdated');
        }
        catch (error) {
            //
        }
    }
    cancelDeleteCategory() {
        this.isConfirmingDeleteCategory.dialog = false;
        this.isConfirmingDeleteCategory.categoryId = '';
        this.isAddingSkillSet = false;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get canAddSkillSet() {
        return this.user.hasRole([RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.ROOT]);
    }
    get canRemoveSkillSet() {
        return this.user.hasRole([RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.ROOT]);
    }
    get skillCategories() {
        const categories = [{
                id: null,
                name: this.$t('progress.skill.general'),
            }];
        this.skills.forEach((skill) => {
            if (skill.category && skill.category.id && !categories.some((category) => category.id === skill.category.id)) {
                categories.push({
                    id: skill.category.id,
                    name: skill.category.name,
                });
            }
        });
        return categories;
    }
    get exludedCategories() {
        // filters out the manual category => map the ids
        return this.skillCategories
            .filter((category) => category.id)
            .map((category) => category.id);
    }
    get canAddNewSkill() {
        return !this.isAddingNewSkill && this.user.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.BOARD]);
    }
    // protected get skills(): Skill[] {
    //   const currentSkillSet =  this.skillSets.find(skillSet => skillSet.id === this.activeTab)
    //   return currentSkillSet && currentSkillSet.skills ? currentSkillSet.skills : [];
    // }
    get dialogOptions() {
        return {
            title: this.$t('progress.dialog.title').toString(),
            text: this.$t('progress.dialog.subtitle', { item: this.$tc('progress.skill.title', 2) }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.updateSkills();
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.isUpdatingSkills = false;
                    },
                },
            },
        };
    }
    // Watchers
    onPortfolioChange(value, oldValue) {
        if (value === oldValue) {
            return;
        }
        this.initialize();
    }
    onPortfolioSkillsChange(value, oldValue) {
        this.initialize();
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], ProgressSkill.prototype, "student", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_b = typeof PortfolioModel !== "undefined" && PortfolioModel) === "function" ? _b : Object)
], ProgressSkill.prototype, "portfolio", void 0);
__decorate([
    Watch('portfolio', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProgressSkill.prototype, "onPortfolioChange", null);
__decorate([
    Watch('portfolio.skills', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProgressSkill.prototype, "onPortfolioSkillsChange", null);
ProgressSkill = __decorate([
    Component({
        components: {
            AddSkillsetDialog,
        },
    })
], ProgressSkill);
export default ProgressSkill;
